var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ui-input-radio", class: _vm.wrapperClass }, [
    _c(
      "input",
      _vm._b(
        {
          staticClass: "radio-custom",
          attrs: { id: _vm.id, type: "radio" },
          domProps: { value: _vm.value, checked: _vm.isChecked }
        },
        "input",
        _vm.$attrs,
        false
      )
    ),
    _vm._v(" "),
    _c("label", { attrs: { for: _vm.id } }),
    _vm._v(" "),
    _c("label", { attrs: { for: _vm.id } }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }